export interface OrderPropertyReport {
  heading: string;
  text: boolean;
  boolean: boolean;
  displayText: string;
  trueString: string;
}
